export function assert(v: unknown, err?: string): asserts v {
    if (!v) {
        throw new Error(err || 'Assertion');
    }
}

export function assertUser(v: unknown, err: string): asserts v {
    if (!v) {
        throw new UserError(err);
    }
}

export function assertValue<T>(v: T | undefined | null, err?: string): T {
    if (v === null || v === undefined) {
        throw new UserError(err || 'Assertion');
    } else {
        return v;
    }
}

/**
 * Error caused by the user and thus the message should be propagated to them.
 */
export class UserError extends Error {

    public override name = 'UserError';

}
